// @flow

export const FILTERS = {
    LOCATION: "Location",
    LISTINGTYPE: "Listing type",
    BUDGET: "Budget",
    COUNTRY: "Country",
    TYPE: "Type",
};
